import { render } from "./tab.vue?vue&type=template&id=466a94ea"
import script from "./tab.vue?vue&type=script&lang=js"
export * from "./tab.vue?vue&type=script&lang=js"

import "./tab.vue?vue&type=style&index=0&id=466a94ea&lang=css"
script.render = render

export default script